import api from '../../plugins/api';

const getAppRefresh = () => {
  return api.get('/api/crm/reports/app-refresh');
};

export default getAppRefresh;
